import WatchlistCta from 'components/watchlist/WatchlistCta';
import NotificationBar from 'components/notifications/NotificationBar';
import FloatingTooltip from 'components/watchlist/FloatingTooltip';
import { dispatchCustomEvent, dispatchEventToAllCarousels } from './highlight/helpers';
import Highlight from './highlight/Highlight';
import HighlightCarousel from './highlight/carousel/HighlightCarousel';

const CONTENT_SHOW = 'show';
const CONTENT_MOVIE = 'movie';

export class PeekAheadWatchlistCta extends WatchlistCta {
    constructor(element) {
        super(null, true);
        this.element = element;
        this.slideCycleCount = 0;
        this.parentSlidePosition =
            parseInt(element.parentElement.parentElement.getAttribute('aria-label')) - 1;
        try {
            this._init();
        } catch (e) {
            //
        }
    }

    init() {
        // The base class runs this method on a listener on the constructor
        // so it's not implemented on this child class
    }

    _init() {
        const self = this;

        // Inits tracking
        this.initTracking();

        self._ = this.element;

        self._cta = self._.querySelector('.watchlistCta');
        self._aaLink = self._cta.getAttribute('aa-link');
        self.contentType =
            self._aaLink.split('|')[5] === CONTENT_MOVIE ? CONTENT_MOVIE : CONTENT_SHOW;
        self.contentId =
            self.contentType === CONTENT_SHOW
                ? (self._aaLink.split('|')[6] ?? 0)
                : (self._aaLink.split('|')[9] ?? 0);
        self.contentItem = null;
        self.watchlistId = `watchlist-cta-${self.contentId}`;

        this._notificationBar = new NotificationBar();
        this._floatingTooltip = new FloatingTooltip(this.contentType === CONTENT_MOVIE);

        let cta = this._cta;

        cta.parentElement.addEventListener('click', (e) => {
            e.preventDefault();
            self.ctaClickHandler();
        });
        cta.parentElement.addEventListener('mouseenter', () => {
            //self.showTooltip();
            cta.classList.add('hovered');
        });
        cta.parentElement.addEventListener('mouseleave', () => cta.classList.remove('hovered'));

        // Adding "initialized" class
        cta.parentElement.classList.add('initialized');

        // Adding "content id" and "content type"
        self._cta.id = self.watchlistId;
        self._cta.classList.add('watchlistCta');
        cta.setAttribute('data-content_type', self.contentType);
        cta.setAttribute('data-content_id', self.contentId);
    }

    getTrackingParams() {
        if (this._aaLink !== undefined) {
            let aaLinkData = this._aaLink.split('|');
            return {
                pageType: 'front_door',
                rowHeaderTitle: 'Home Marquee',
                showSeriesId: !this.isMovie() ? this.contentId : '',
                showSeriesTitle: !this.isMovie() ? aaLinkData[7] : '',
                showGenre: aaLinkData[21] ?? '',
                showEpisodeId: '',
                showEpisodeTitle: '',
                showEpisodeNumber: '',
                showSeasonNumber: '',
                movieId: this.isMovie() ? this.contentId : '',
                movieTitle: this.isMovie() ? aaLinkData[7] : '',
                movieGenre: this.isMovie() ? aaLinkData[11] : '',
                contentLocked: aaLinkData[17] ? aaLinkData[17] : '',
                slideCycle: this.slideCycleCount.toString() ?? '0',
                slideId: aaLinkData[12] ?? '0',
                slideTitle: aaLinkData[7] ?? '',
                slideCTA: aaLinkData[3] ?? '',
                slideType: 'homeSlide',
                slideTarget: aaLinkData[14] ?? '',
                posRowNum: '0',
                posColNum: this.parentSlidePosition.toString(),
            };
        }
    }

    refreshMYListCarousel() {
        dispatchCustomEvent(this.element, Highlight.MY_LIST_CAROUSEL_EVENT_TYPE);
    }

    addToWatchlist() {
        super.addToWatchlist().then(() => {
            this.refreshMYListCarousel();
            this.__spreadState();
        });
    }

    removeFromWatchlist() {
        super.removeFromWatchlist().then(() => {
            this.refreshMYListCarousel();
            this.__spreadState();
        });
    }

    __spreadState() {
        dispatchEventToAllCarousels(
            new CustomEvent(HighlightCarousel.STATE_CAROUSEL_EVENT_TYPE, {
                detail: {
                    toggleClassName: WatchlistCta.IN_WATCHLIST_CLASS,
                    elementId: this.contentId,
                },
            }),
        );
    }

    setSlideCycleState(cycleCount) {
        this.slideCycleCount = cycleCount;
    }
}
